var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0h27a4 4 0 014 4v46a4 4 0 01-4 4H4a4 4 0 01-4-4V13z",
    fill: "#b0d3f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0v9a4 4 0 01-4 4H0z",
    fill: "#90bae1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 5h-6a1 1 0 010-2h6a1 1 0 010 2zM40 5h-2a1 1 0 010-2h2a1 1 0 010 2z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2980ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 19H8a1 1 0 010-2h9a1 1 0 010 2zM30 19h-8a1 1 0 010-2h8a1 1 0 010 2zM23 24H8a1 1 0 010-2h15a1 1 0 010 2zM17 29H8a1 1 0 010-2h9a1 1 0 010 2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40 31.7a10.779 10.779 0 00-5.68 4.87 7.809 7.809 0 00-4.49-1.42 7.437 7.437 0 00-7.58 7.27c.003 1.24.33 2.457.95 3.53a6.238 6.238 0 00-4.2 5.82 5.9 5.9 0 00.43 2.23 6.5 6.5 0 006.07 4h26a6.37 6.37 0 006.5-6.23 6.246 6.246 0 00-4.34-5.87 10.015 10.015 0 001.09-4.52A10.378 10.378 0 0048 31.77z",
    fill: "#3b97d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 45h3a1 1 0 001-1V23a1 1 0 011-1h2.969a1 1 0 00.793-1.61l-7.969-10.36a1 1 0 00-1.586 0l-7.969 10.36a1 1 0 00.793 1.61H39a1 1 0 011 1v21a1 1 0 001 1z",
    fill: "#ff5364"
  }))));
}

export default __webpack_public_path__ + "5e119f529b89aa27dca0a54d78c9d0b8.svg";
export { SvgUpload as ReactComponent };